import Pepperoni from "../assets/pepperoni.jpg";
import Margherita from "../assets/margherita.jpg";
import PedroTechSpecial from "../assets/pedrotechspecial.jpg";
import Vegan from "../assets/vegan.jpg";
import Pineapple from "../assets/pineapple.jpg";
import Expensive from "../assets/expensive.jpg";
export const MenuList = [
    {
      name: "Pepperoni Pizza",
      image: Pepperoni,
      price: 149,
    },
    {
      name: "Margherita Pizza",
      image: Margherita,
      price: 119,
    },
    {
      name: "PedroTech Special Pizza",
      image: PedroTechSpecial,
      price: 259,
    },
    {
      name: "Vegan Pizza",
      image: Vegan,
      price: 169,
    },
    {
      name: "Pineapple Pizza",
      image: Pineapple,
      price: 149,
    },
    {
      name: "Very Expensive Pizza",
      image: Expensive,
      price: 1999,
    },
  ];